

























import { Component, Vue, Prop } from 'vue-property-decorator'
import { getCountryCodeAndPhone, isPhoneNumber } from '@/utils/helpers'
import CustomAutocomplete from '@/components/CustomAutocomplete.vue'

@Component({
  components: {
    CustomAutocomplete
  }
})
export default class Autocomplete extends Vue {
  @Prop() apiPath!: string
  @Prop({ default: '' }) source?: string
  @Prop({ default: 'query' }) queryField?: string
  @Prop({ default: 'label' }) optionLabel?: string | string[]
  @Prop({ default: 'label' }) inputValue?: string | string[]
  @Prop({ default: () => ({}) }) filter?: object
  @Prop({ default: 'Type to search' })
  placeholder?: string
  @Prop({ default: '' }) sortByField?: string
  @Prop({ default: 'asc' }) sortType?: string
  @Prop({ default: false }) canAddNewUser?: boolean

  getValue() {
    let customAutocomplete = this.$refs.suggest as CustomAutocomplete
    if (customAutocomplete) {
      return customAutocomplete.getValue()
    }
    return ''
  }

  setValue(val: string = '') {
    let customAutocomplete = this.$refs.suggest as CustomAutocomplete
    if (customAutocomplete) {
      customAutocomplete.setValue(val)
    }
  }

  onAddNewUser() {
    const inputValue = this.getValue()
    const isPhone = isPhoneNumber(inputValue)
    const data = {
      customerName: '',
      phoneNumber: '',
      countryCode: ''
    }
    if (isPhone) {
      const { phoneNumber, countryCode } = getCountryCodeAndPhone(inputValue)
      data.phoneNumber = phoneNumber || ''
      data.countryCode = countryCode || ''
    } else {
      data.customerName = inputValue || ''
    }
    this.$emit('add-new-user', data)
  }

  emitInputText(item) {
    this.$emit('input-text', item)
  }
}
